import { render, staticRenderFns } from "./RichContent.vue?vue&type=template&id=5fb4138a&scoped=true"
import script from "./RichContent.vue?vue&type=script&lang=js"
export * from "./RichContent.vue?vue&type=script&lang=js"
import style0 from "./RichContent.vue?vue&type=style&index=0&id=5fb4138a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb4138a",
  null
  
)

export default component.exports